import jsbarcode from 'jsbarcode';
import { useEffect, useRef } from 'react';

type BarcodeOptions = Omit<jsbarcode.Options, 'format'> & {
  format?:
    | 'CODE128'
    | 'CODE39'
    | 'EAN13'
    | 'UPC'
    | 'EAN8'
    | 'EAN5'
    | 'EAN2'
    | 'ITF14'
    | 'MSI'
    | 'MSI10'
    | 'MSI11'
    | 'MSI1010'
    | 'MSI1110'
    | 'pharmacode'
    | 'codabar';
};

interface BarcodeProps {
  code: string;
  options?: BarcodeOptions;
}

export const Barcode = (props: BarcodeProps) => {
  const { code, options } = props;
  const ref = useRef(null);

  useEffect(() => {
    jsbarcode(ref.current, code, options);
  }, [code, options]);

  return <svg ref={ref} />;
};
